var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMedalCopper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 41,
    viewBox: "0 0 32 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_425)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4503 18.9043C32.8486 10.2709 26.9834 2.13866 18.3501 0.740358C9.7167 -0.65794 1.58444 5.20723 0.18614 13.8406C-1.21216 22.4739 4.65301 30.6062 13.2864 32.0045C21.9197 33.4028 30.052 27.5376 31.4503 18.9043Z",
    fill: "url(#paint0_linear_75_425)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97086 40.3817L6.8037 37.5665C6.5691 37.4492 6.4518 37.3319 6.09989 37.3319L2.11162 36.98C1.87702 36.98 1.64241 36.6281 1.75972 36.3935L7.39022 23.4902L16.3052 27.3612L10.5574 40.2644C10.5574 40.499 10.0882 40.6163 9.85356 40.3817H9.97086Z",
    fill: "url(#paint1_linear_75_425)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8187 40.3817L24.9858 37.5665C25.2204 37.4492 25.3377 37.3319 25.6897 37.3319L29.6779 36.98C29.9125 36.98 30.1471 36.6281 30.0298 36.3935L24.3993 23.4902L15.4844 27.3612L21.2322 40.2644C21.2322 40.499 21.7014 40.6163 21.936 40.3817H21.8187Z",
    fill: "url(#paint2_linear_75_425)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4848 19.8106C32.3784 11.7373 27.3688 3.65755 19.2955 1.76398C11.2222 -0.129588 3.14249 4.88005 1.24892 12.9533C-0.644646 21.0266 4.365 29.1063 12.4383 30.9999C20.5115 32.8935 28.5913 27.8838 30.4848 19.8106Z",
    fill: "url(#paint3_linear_75_425)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6013 18.8993C27.9919 12.9705 24.3129 7.03698 18.3841 5.64639C12.4553 4.2558 6.52176 7.93476 5.13117 13.8636C3.74058 19.7924 7.41953 25.7259 13.3483 27.1165C19.2772 28.5071 25.2107 24.8282 26.6013 18.8993Z",
    fill: "url(#paint4_linear_75_425)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39694 16.9215C5.39694 10.8218 10.3236 5.8951 16.4233 5.8951C22.523 5.8951 21.9365 7.06812 23.9307 8.82766C21.9365 6.71622 19.1213 5.30859 15.9541 5.30859C9.85442 5.30859 4.92773 10.2353 4.92773 16.335C4.92773 22.4347 6.33536 22.3174 8.4468 24.3115C6.56996 22.3174 5.51424 19.7367 5.51424 16.8042L5.39694 16.9215Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8368 5.4259H15.6022C21.2327 5.5432 25.8075 10.118 25.8075 15.8658C25.8075 21.6136 21.1154 26.3057 15.3676 26.3057C9.61982 26.3057 5.04504 21.7309 4.92773 16.1004V16.335C4.92773 22.4347 9.85442 27.3614 15.9541 27.3614C22.0538 27.3614 26.9805 22.4347 26.9805 16.335C26.9805 10.2353 22.0538 5.30859 15.9541 5.30859L15.8368 5.4259Z",
    fill: "#591706"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6217 20.6771C15.3604 20.6771 15.0337 20.6538 14.6417 20.6071C14.2591 20.5698 13.8764 20.5138 13.4937 20.4391C13.1111 20.3551 12.7937 20.2618 12.5417 20.1591V17.8351C12.9524 18.0218 13.3911 18.1571 13.8577 18.2411C14.3337 18.3251 14.7584 18.3671 15.1317 18.3671C15.5891 18.3671 15.9297 18.3158 16.1537 18.2131C16.3777 18.1011 16.4897 17.9004 16.4897 17.6111C16.4897 17.1911 16.1491 16.9811 15.4677 16.9811H13.8857L14.0677 15.0351H15.3837C15.7291 15.0351 15.9717 14.9838 16.1117 14.8811C16.2611 14.7691 16.3357 14.5964 16.3357 14.3631C16.3357 14.1484 16.2331 13.9851 16.0277 13.8731C15.8224 13.7611 15.4957 13.7051 15.0477 13.7051C14.6184 13.7051 14.1891 13.7564 13.7597 13.8591C13.3304 13.9524 12.9664 14.0784 12.6677 14.2371V11.9131C13.0411 11.7638 13.4937 11.6378 14.0257 11.5351C14.5577 11.4324 15.0944 11.3811 15.6357 11.3811C16.4291 11.3811 17.1057 11.4978 17.6657 11.7311C18.2257 11.9644 18.6551 12.2818 18.9537 12.6831C19.2524 13.0751 19.4017 13.5278 19.4017 14.0411C19.4017 14.8998 19.1217 15.5578 18.5617 16.0151C18.8791 16.1644 19.1264 16.3931 19.3037 16.7011C19.4811 16.9998 19.5697 17.3824 19.5697 17.8491C19.5697 18.5024 19.3971 19.0391 19.0517 19.4591C18.7064 19.8791 18.2351 20.1871 17.6377 20.3831C17.0497 20.5791 16.3777 20.6771 15.6217 20.6771Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_425",
    x1: 2.55141,
    y1: 3.07731,
    x2: 26.9502,
    y2: 27.4761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E96800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#7F2E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF4500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_425",
    x1: 6.92101,
    y1: 36.2762,
    x2: 9.50165,
    y2: 30.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A00505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_425",
    x1: 24.5166,
    y1: 36.1589,
    x2: 22.0533,
    y2: 30.1765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A00505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_425",
    x1: 29.7488,
    y1: 30.1855,
    x2: 4.8808,
    y2: 5.31751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E96800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#7F2E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF4500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_425",
    x1: 25.5253,
    y1: 25.9622,
    x2: 1.9476,
    y2: 2.38447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E96800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#7F2E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF4500"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.7889,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedalCopper);
export default __webpack_public_path__ + "static/media/icon-medal-copper.5c57e2a37e601d5270b59800d4d5951b.svg";
export { ForwardRef as ReactComponent };